const salaryTaxRates = [
	{
		path: '/salary-tax-rates/list',
		name: 'jobs-salary-tax-rates-list',
		component: () => import(/* webpackChunkName: "SalaryTaxRatesList" */ '@/views/jobs/salary-tax-rates/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,salary',
		},
	},
]

export default salaryTaxRates
